/**
 * Permission to send the user's text to third-party AI, as App Store
 * guideline 5.1.2(i) requires: the iOS app can't be used without it, as
 * translations and most features use AI. Each account agrees once
 * (`aiConsentedAt`), in the app's native sheet (AIConsentView.swift); the
 * website doesn't ask.
 */
import * as iOSBridge from "iOSBridge";
import readlangClient from "readlangClient";
import stores from "stores/stores";

let asking = false;

const agree = async () => {
  const { data } = await readlangClient.request<{ aiConsentedAt: string }>(
    "POST",
    "/api/user/aiConsent",
    {}
  );
  stores.user.patch({ aiConsentedAt: data.aiConsentedAt });
};

/** In the iOS app, asks a signed-in user who hasn't agreed yet */
export const requireInApp = async () => {
  const app = iOSBridge.get();
  if (asking || !app || stores.user.state.value.aiConsentedAt) {
    return;
  }
  asking = true;
  try {
    if (await readlangClient.isLocalMode()) {
      return;
    }
    const choice = await app.requestAIConsent();
    if (choice === "agree") {
      await agree();
    } else if (choice === "signOut") {
      readlangClient.logout();
    }
  } finally {
    // Unless agreed, the next page asks again
    asking = false;
  }
};
